module.exports = __webpack_public_path__ + "images/3a7201c22811e52d676e391bf2cbbf41-Lauderdale.png";